// 用户提交
const WorkOrderServices = () => import('@/views/workOrder/services/index.vue') // 园区办事
const WorkOrderSpaceReservation = () => import('@/views/workOrder/spaceReservation/index.vue') // 空间预定
const WorkOrderCleaning = () => import('@/views/workOrder/cleaning/index.vue') // 园区保洁
const WorkOrderGreenPlants = () => import('@/views/workOrder/greenPlants/index.vue') // 绿植租赁
const WorkOrderPrinting = () => import('@/views/workOrder/printing/index.vue') // 打印申请
const WorkOrderFeedback = () => import('@/views/workOrder/feedback/index.vue') //投诉建议

export default {
  WorkOrderServices,
  WorkOrderSpaceReservation,
  WorkOrderCleaning,
  WorkOrderGreenPlants,
  WorkOrderPrinting,
  WorkOrderFeedback
}
